module.exports = "<div class=\"wx-sidebar\">\n  <div class=\"wx-sidebar-content\">\n    <ul>\n      <li v-for=\"link in links\">\n        <router-link tag=\"a\" :to=\"link.path\" v-if=\"link.type === linkType.link\">\n          <span class=\"iconfont\" :class=\"link.icon\"></span>\n          <div class=\"text\">{{link.name}}</div>\n        </router-link>\n        <div class=\"deviding-line\" v-if=\"link.type === linkType.dividing\"></div>\n      </li>\n    </ul>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar/sidebar.html
// module id = ./src/components/sidebar/sidebar.html
// module chunks = 4